// extracted by mini-css-extract-plugin
module.exports = {"resourceVersions":"resourceVersions___3vHUe","resourceVersion":"resourceVersion___NE5fM","versionText":"versionText___3YwHQ"};